import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/acceuil.css";

export default function Accueilsection() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [contentVisible, setContentVisible] = useState(false);
    const accueilRef = useRef(null);
    const { t } = useTranslation("Accueil"); // Utilisez le namespace 'accueil'

    const slides = [
        {
            titleKey: "slide1Title", // Clé de traduction pour le titre
            descriptionKey: "slide1Description", // Clé de traduction pour la description
            imageUrl: require("../../assets/image/table1.webp"),
        },
        {
            titleKey: "slide2Title",
            descriptionKey: "slide2Description",
            imageUrl: require("../../assets/image/table3.webp"),
        },
        {
            titleKey: "slide3Title",
            descriptionKey: "slide3Description",
            imageUrl: require("../../assets/image/acceuil1a.webp"),
        },
    ];

    useEffect(() => {
        const handleScroll = () => {
            if (accueilRef.current) {
                const rect = accueilRef.current.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    setContentVisible(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
        }, 10000);

        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <section id="accueil">
            <div className="conteneur">
                <div
                    className="accueil-section"
                    ref={accueilRef}
                    style={{
                        backgroundImage: `url(${slides[currentSlide].imageUrl})`,
                    }}
                >
                    <div
                        className={`accueil-content ${
                            contentVisible ? "visible" : ""
                        }`}
                    >
                        <h2 className="accueil-title">
                            {t(slides[currentSlide].titleKey)}
                        </h2>
                        <p className="accueil-description">
                            {t(slides[currentSlide].descriptionKey)}
                        </p>
                        <a href="#ServiceRequest" className="accueil-button">
                            {t("reserveHere")}{" "}
                            {/* Clé de traduction pour "Réservez ici !" */}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
